var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHomeIconOutlineMono = function SvgHomeIconOutlineMono(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M12 2c.68 0 1.35.23 1.89.65l6.54 5.1A4.1 4.1 0 0 1 22 10.98v7.86A3.16 3.16 0 0 1 18.83 22h-4.1a1 1 0 0 1-1-1v-7.21h-3.46V21a1 1 0 0 1-1 1h-4.1A3.17 3.17 0 0 1 2 18.84v-7.86a4.1 4.1 0 0 1 1.57-3.23l6.54-5.1C10.65 2.23 11.3 2 12 2m0 2q-.28 0-.51.13l-.15.1-6.54 5.1a2.1 2.1 0 0 0-.8 1.65v7.86c0 .64.52 1.16 1.17 1.16h3.1v-7.21a1 1 0 0 1 1-1h5.46a1 1 0 0 1 1 1V20h3.1A1.17 1.17 0 0 0 20 18.84v-7.86a2.1 2.1 0 0 0-.8-1.65l-6.54-5.1A1 1 0 0 0 12 4",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHomeIconOutlineMono);
export default ForwardRef;